import { LANGUAGE } from "@/common/utils/constants.js";

export const ADDITIONAL_INFORMATION_DOCX = {
	[LANGUAGE.en.short]: {
		title: `Additional Information`,
		projectDeliveryLocations: 'Project Delivery Locations',
		clientLocationsCovered: 'Client’s Locations Covered',
		duration: 'Duration',
		ftes: "FTEs",
		techPractices: 'Tech Practices',
		subTechPractices: "Sub Tech Practices",
		serviceLines: 'Type of Business',
		models: 'Models',
		certificates: 'Certifications',
		tools: "Tools",
		ongoing: 'Ongoing project',
		revenue: 'Revenue',
		challenges: 'Challenges',
		ourSolution: 'Our Solution',
		results: 'Results',
		reworked: "Rework this section from DRC Client context section.",
		deleteYellowBox: "1. Delete this yellow box",
		integrateContent: "2. Integrate your content.",
		ifFontSmall: "3. If the size of the font is smaller to 10,5 summarize more your content.",
		max500: "(500 chars max.)",
		reworkedResults: "Rework this section from Client Results section",
		max800: "(800 chars max.)",
		reworkedSolution: "Rework this section from Solution section.",
	},
	[LANGUAGE.de.short]: {
		title: `Weitere Informationen`,
		projectDeliveryLocations: 'Standorte für die Projektabwicklung',
		clientLocationsCovered: 'Abgedeckte Standorte des Kunden',
		duration: 'Dauer',
		ftes: "FTEs",
		techPractices: 'Technische Praktiken',
		subTechPractices: "Sub-Tech-Praktiken",
		serviceLines: 'Geschäftsart',
		models: 'Modelle',
		certificates: 'Zertifizierungen',
		tools: "Werkzeuge",
		ongoing: 'Laufendes Projekt',
		revenue: 'Einnahmen',
		challenges: 'Herausforderungen',
		ourSolution: 'Unsere Lösung',
		results: 'Ergebnisse',
		reworked: "Diesen Abschnitt aus dem DRC-Client-Kontext neu erstellt.",
		deleteYellowBox: "1. Löschen Sie dieses gelbe Feld",
		integrateContent: "2. Integrieren Sie Ihren Inhalt.",
		ifFontSmall: "3. Wenn die Schriftgröße kleiner als 10,5 ist, fassen Sie Ihren Inhalt zusammen.",
		max500: "(max. 500 Zeichen)",
		reworkedResults: "Diesen Abschnitt aus dem Bereich Ergebnisse des Kunden neu erstellt",
		max800: "(max. 800 Zeichen)",
		reworkedSolution: "Diesen Abschnitt aus dem Lösungsbereich neu erstellt.",
	},
	[LANGUAGE.fr.short]: {
		title: `Informations Complémentaires`,
		projectDeliveryLocations: 'Lieux de livraison du projet',
		clientLocationsCovered: 'Emplacements du client couverts',
		duration: 'Durée',
		ftes: "FTEs",
		techPractices: 'Pratiques techniques',
		subTechPractices: "Pratiques sous-technologiques",
		serviceLines: 'Type d\'activité',
		models: 'Des modèles',
		certificates: 'Certifications',
		tools: "Outils",
		ongoing: 'Projet en cours',
		revenue: 'Revenu',
		challenges: 'Défis',
		ourSolution: 'Notre solution',
		results: 'Résultats',
		reworked: "Cette section a été retravaillée à partir de la section Contexte client de DRC.",
		deleteYellowBox: "1. Supprimez cette boîte jaune",
		integrateContent: "2. Intégrez votre contenu.",
		ifFontSmall: "3. Si la taille de la police est inférieure à 10,5, résumez davantage votre contenu.",
		max500: "(500 caractères max.)",
		reworkedResults: "Cette section a été retravaillée à partir de la section Résultats du client",
		max800: "(800 caractères max.)",
		reworkedSolution: "Cette section a été retravaillée à partir de la section Solution.",
	},
	[LANGUAGE.it.short]: {
		title: `Informazioni aggiuntive`,
		projectDeliveryLocations: 'Luoghi di consegna del progetto',
		clientLocationsCovered: 'Sedi del cliente coperte',
		duration: 'Durata',
		ftes: "FTEs",
		techPractices: 'Pratiche tecnologiche',
		subTechPractices: "Pratiche sub-tecnologiche",
		serviceLines: 'Tipologia di attività',
		models: 'Modelli',
		certificates: 'Certificazioni',
		tools: "Utensili",
		ongoing: 'Progetto in corso',
		revenue: 'Reddito',
		challenges: 'Sfide',
		ourSolution: 'La nostra soluzione',
		results: 'Risultati',
		reworked: "Rielaborato questa sezione dal contesto del cliente DRC.",
		deleteYellowBox: "1. Elimina questa casella gialla",
		integrateContent: "2. Integra il tuo contenuto.",
		ifFontSmall: "3. Se la dimensione del carattere è inferiore a 10,5, riassumi ulteriormente il tuo contenuto.",
		max500: "(max 500 caratteri)",
		reworkedResults: "Rielaborato questa sezione dalla sezione Risultati del cliente",
		max800: "(max 800 caratteri)",
		reworkedSolution: "Rielaborato questa sezione dalla sezione Soluzione.",
	},
	[LANGUAGE.ja.short]: {
		title: `追加情報`,
		projectDeliveryLocations: 'プロジェクトの納品場所',
		clientLocationsCovered: '対象となるクライアントの所在地',
		duration: '間隔',
		ftes: "FTEs",
		techPractices: '技術実践',
		subTechPractices: "サブテクノロジーの実践",
		serviceLines: '事業の種類',
		models: 'モデル',
		certificates: '認証',
		tools: "ツール",
		ongoing: '進行中のプロジェクト',
		revenue: '収益',
		challenges: '課題',
		ourSolution: '私たちの解決策',
		results: '結果',
		reworked: "このセクションをDRCクライアントコンテキストセクションから再作成しました。",
		deleteYellowBox: "1. この黄色いボックスを削除",
		integrateContent: "2. コンテンツを統合します。",
		ifFontSmall: "3. フォントサイズが10.5未満の場合は、コンテンツをさらに要約してください。",
		max500: "(最大500文字)",
		reworkedResults: "このセクションをクライアントの結果セクションから再作成しました",
		max800: "(最大800文字)",
		reworkedSolution: "このセクションをソリューションセクションから再作成しました。",
	},
	[LANGUAGE.es.short]: {
		title: `Información Adicional`,
		projectDeliveryLocations: 'Ubicaciones de entrega del proyecto',
		clientLocationsCovered: 'Ubicaciones del cliente cubiertas',
		duration: 'Duración',
		ftes: "FTEs",
		techPractices: 'Prácticas tecnológicas',
		subTechPractices: "Sub-prácticas tecnológicas",
		serviceLines: 'Tipo de negocio',
		models: 'Modelos',
		certificates: 'Certificaciones',
		tools: "Herramientas",
		ongoing: 'Proyecto en curso',
		revenue: 'Ingresos',
		challenges: 'Desafíos',
		ourSolution: 'Nuestra solución',
		results: 'Resultados',
		reworked: "Rehacer esta sección desde la sección de contexto del cliente DRC.",
		deleteYellowBox: "1. Eliminar esta caja amarilla",
		integrateContent: "2. Integrar su contenido.",
		ifFontSmall: "3. Si el tamaño de la fuente es menor a 10,5, resumir más su contenido.",
		max500: "(máx. 500 caracteres)",
		reworkedResults: "Rehacer esta sección desde la sección Resultados del Cliente",
		max800: "(máx. 800 caracteres)",
		reworkedSolution: "Rehacer esta sección desde la sección Solución.",
	}
}
